import { Box, Button, Dialog, DialogContent, Typography, useTheme } from '@mui/material'
import { LoginOutlined } from '@mui/icons-material'
import { observer } from 'mobx-react'

import DownloadStatusListDialog from '../../study-material/DownloadStatusListDialog'
import { useLayoutContext } from '../../../../shared/contexts/layout.context'
import Navbar from '../faculty/PresenterNavbar'
import sessionEndedImg from '../../../../shared/assets/waiting.svg'
import { Outlet, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../../store/auth.store'
import React, { useCallback, useEffect } from 'react'
import AuditingSideDrawer from './AuditingSideDrawer'
import aliveLogoImg from '../../../../shared/assets/alivelogo.png'


const AuditingLayout = observer( ( { navHeadText } ) => {

    const { minSidebarCollapseWidth, setMenuState } = useLayoutContext()

    const navigate = useNavigate()
    const { palette, theme } = useTheme()

    const AuthStore = useAuthStore()

    const handleResizeOrLoad = useCallback( () => {
        if ( window.innerWidth < minSidebarCollapseWidth )
            setMenuState( false )
        else {
            setMenuState( true )
        }
    }, [minSidebarCollapseWidth, setMenuState] )

    useEffect( () => {
        window.addEventListener( 'resize', handleResizeOrLoad )
        window.addEventListener( 'load', handleResizeOrLoad )
        return () => {
            window.removeEventListener( 'resize', handleResizeOrLoad )
            window.removeEventListener( 'load', handleResizeOrLoad )
        }
    }, [handleResizeOrLoad] )

    return (
        <Box
            sx={{
                flexDirection: { sm: "row", xs: "column-reverse" },
                bgcolor: palette.layoutBackground,
                display: "flex",
                height: "100%",
                overflow: "auto"
            }}>
            <AuditingSideDrawer />
            <Box
                sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    minWidth: "0",
                    position: "relative",
                    overflow: "auto"
                }}>
                <Navbar navHeadText={navHeadText} closeSideMenu={() => setMenuState( false )} openSideMenu={() => setMenuState( true )} />
                {AuthStore.getErpSessionState !== "ended" &&
                    <Box
                        id="page-content"
                        className={theme}
                        sx={{
                            bgcolor: palette.background.default,
                            overflow: "auto",
                            borderRadius: { sm: "10px 0 0 0", xs: "0" },
                            flexGrow: 1,
                            display: "flex",
                            minWidth: "0",
                            position: "relative"
                        }}>
                        <Box
                            sx={{
                                position: "absolute",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 100,
                                inset: 0,
                                opacity: "0.1",
                                pointerEvents: "none"
                            }}>
                            <Box
                                component="img"
                                src={aliveLogoImg}
                                sx={{
                                    width: "30%",
                                    opacity: "0.4"
                                }} />
                        </Box>
                        <Outlet />
                    </Box>}
            </Box>
            <Dialog open={AuthStore.getErpSessionState === "ended"}>
                <DialogContent >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "20px",
                            flexDirection: "column"
                        }}>
                        <img width="200px" src={sessionEndedImg} alt="Session ended!" />
                        <Typography variant='subtitle2' sx={{
                            textAlign: "center"
                        }}>Your ERP session seems to have ended! did you log in using ERP credentials somewhere else? please login again.</Typography>
                        <Button onClick={() => navigate( `/?redirect=${window.location.pathname}` )} startIcon={<LoginOutlined fontSize='small' />} variant='outlined' sx={{ textTransform: "capitalize" }}>Sign In</Button>
                    </Box>
                </DialogContent>
            </Dialog>
            <DownloadStatusListDialog />
        </Box>
    );
} )

export default AuditingLayout
